// extracted by mini-css-extract-plugin
export default {"header":"Table_header__Lh3R0","link":"Table_link__9stTA","active":"Table_active__4ceFh","inactive":"Table_inactive__eoCBb"};